import React from 'react';
import cx from 'classnames';

const OrderId = ({ id, isSelected, isOpen, className }) => {
  return <div className={cx(className, { selected: isSelected, open: isOpen })}>J{id}</div>;
};

export default OrderId;
